// Module
var code = `<main class="flex flex-col flex-grow gap-4 p-page"> <app-replenishment-table [filtersSelectionSetId]="this.filtersSelectionSetId" class="flex-grow"></app-replenishment-table> </main> `;
// Exports
export default code;